<template>
    <div class="uk-field-group form-link-input">
        <form-segmented-control
            :id="`scope-${record.id}`"
            name="scope"
            v-model="record.scope"
            :glyph="glyph"
            :options="methods"
            :selectable="record.scope !== 'main'"
            :editable="editable"
            @input="save_scope"
        >
            <template
                v-slot:label
            >
                ({{ record.scope | nibnut.ucfirst }})
            </template>
        </form-segmented-control>

        <form-phone-input
            v-if="record.method.match(/(phone|mobile)/i)"
            :id="`address-${record.id}`"
            name="address"
            :value="record.address | nibnut.phone(true)"
            :editable="editable"
            :extension-field="!!record.method.match(/(phone)/i)?'extension':''"
            :extension="record.extension"
            @input="save"
        />
        <form-input
            v-else-if="record.method.match(/(email|url)/i)"
            :id="`address-${record.id}`"
            v-model="record.address"
            name="address"
            width="1-1"
            :required="false"
            :editable="editable"
            @input="save"
        />

        <a v-if="record.scope !== 'main'" href class="uk-button" @click.prevent="remove">
            <open-icon glyph="remove" />
        </a>
        <a v-if="!!link" :href="link" class="uk-button" :target="target">
            <open-icon glyph="external-link" />
        </a>
    </div>
</template>

<script type="text/javascript">
import is_nibnut_component from "../mixins/IsNibnutComponent"

import FormSegmentedControl from "./FormSegmentedControl"
import FormPhoneInput from "./FormPhoneInput"
import FormInput from "./FormInput"
import OpenIcon from "./OpenIcon"

export default {
    mixins: [is_nibnut_component],
    components: {
        FormSegmentedControl,
        FormPhoneInput,
        FormInput,
        OpenIcon
    },
    directives: {
        focus: {
            inserted (element) {
                element.focus()
            }
        }
    },
    methods: {
        save (value, name) {
            this.$emit("input", value, name)
        },
        save_scope (value) {
            const matches = value ? value.match(/^([^-]+)-(.+)$/) : ["", ""]
            this.$emit("input", { scope: matches[1], method: matches[2] }, "scope")
        },
        remove () {
            const identifier = (this.record.address ? "\"" + this.record.address + "\"" : "this contact method")
            this.$confirm({
                title: `Delete ${identifier}`,
                message: "Are you sure you want to delete this contact method? Once it's gone, it's gone...",
                cancel: `Keep ${identifier}`,
                ok: `Delete ${identifier}`,
                then: (confirmed) => {
                    if(confirmed) {
                        this.$store.dispatch("RECORD_DELETE", {
                            entity: "contact_method",
                            id: this.record.id
                        })
                    }
                }
            })
        }
    },
    computed: {
        link () {
            if(this.record.method === "email") return "mailto:" + this.record.address
            if((this.record.method === "phone") || (this.record.method === "mobile")) {
                let number = this.record.address.replace(/[^\d]+/g, "")
                if((this.record.method === "phone") && this.record.extension) number += "p" + this.record.extension
                if(!number) return ""
                return "tel:" + number
            }
            return this.record.address
        },
        target () {
            if((this.record.method === "url") || (this.record.method === "email")) return "_blank"
            return ""
        },
        glyph () {
            if(this.record.method === "email") return "paper-plane-o"
            if(this.record.method === "phone") return "phone"
            if(this.record.method === "mobile") return "mobile"
            return "link"
        },
        methods () {
            if((this.record.method === "phone") || (this.record.method === "mobile")) {
                return [
                    { id: "work-phone", title: "Work Phone", method: "phone", scope: "work" },
                    { id: "home-phone", title: "Home Phone", method: "phone", scope: "home" },
                    { id: "work-mobile", title: "Work Mobile", method: "mobile", scope: "work" },
                    { id: "home-mobile", title: "Home Mobile", method: "mobile", scope: "home" }
                ]
            }
            const name = this.nibnut_filter("nibnut.ucfirst", [this.record.method])
            return [
                { title: "Work " + name, method: this.record.method, scope: "work" },
                { title: "Home " + name, method: this.record.method, scope: "home" }
            ]
        }
    },
    props: {
        record: {
            type: Object,
            default: () => { return {} }
        },
        editable: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style lang="less">
    .uk-field-group {
        display: flex;
        flex-wrap: nowrap;

        & > .uk-button-dropdown,
        & > div,
        & > input,
        & > select,
        & > .uk-button {
            flex: 0 1 auto;
        }
        & > .uk-button-dropdown {
            position: relative;

            & > .uk-button {
                padding-right: 20px;
                white-space: nowrap;

                .caret-down {
                    position: absolute;
                    right: 8px;
                    top: 50%;
                    transform: translate(0, -50%);
                }
            }
        }
        & > div,
        & > input,
        & > select {
            flex: 1 2 auto;
        }
        & > select + .uk-button:first-of-type {
            margin-left: 6px;
        }

        &.form-link-input {
            & > .uk-button {
                padding-left: 6px;
                padding-right: 6px;
                opacity: 0.25;
                transition: opacity 280ms cubic-bezier(0.4,0,0.2,1);
            }
            &:hover {
                & > .uk-button {
                    opacity: 1.0;
                }
            }
        }
    }
</style>
